import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_MAILING_LIST_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import {
  arrayNotEmpty,
  getErrorMessage,
  isRequired,
  isLengthCharValid,
} from "../../../../../utils/FormUtils";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import classes from "../WizardForm.module.css";
import { getSitesUnderSelectedScope } from "../../../../../utils/UsersUtils";
import { getRecipientsSelectionEntities } from "../../../../../utils/MessagingUtils";
import MultiSelectBoxInput from "../../../Inputs/CustomInputs/MultiSelectBoxInput";
import { LENGTHS } from "../../../../../config/Config";
import useInputInfos from "../../../../../hooks/useInputInfos";

const MailingListDetailsStep = (props) => {
  const [recipientsSelectionEntities, setRecipientsSelectionEntities] = useState([]);
  const [foundedSelectionEntities, setFoundedSelectionEntities] = useState([]);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const allScopes = useSelector((state) => state.user?.allScopes);
  const sites = useSelector((state) => state.user?.sites);
  const selectedSites = getSitesUnderSelectedScope(sites, allScopes, selectedScope);
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);
  const currentScopeUsers = useSelector((state) => state.messaging.currentScopeUsers);
  const currentGmtUsers = useSelector((state) => state.user.currentGmtUsers);
  const selectedScopeUserTypes = selectedSites.map(site => userTypes.filter(ut => ut.siteId === site.id || ut.siteId === null)).flat();
  const roles = useSelector((state) => state.user?.initialState)?.roles;

  const { inputInfos, handleInputInfo, getInputsStatusByInputInfos } = useInputInfos();
  const [stepHeader, setStepHeader] = useState(new StepHeaderEntity(
    props?.isEditMode ? Strings.STEPS_TITLES.EDIT_MAILING_LIST_TITLE : Strings.STEPS_TITLES.CREATE_NEW_MAILING_LIST_TITLE,
    null,
    Icons.MESSAGING,
    null
  ));

  useEffect(() => {
    store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
  }, [stepHeader]);

  useEffect(() => {
    if (props.currentStep === ADD_MAILING_LIST_FORM_STEPS.MAILING_LIST_DETAILS) {
      const { hasValue, hasError } = getInputsStatusByInputInfos(inputInfos);
      props.handleStateDataChange({["isCurrentStepValid"]: !hasError, ["isCurrentStepHasValues"]: hasValue });
    }
  }, [inputInfos]);

  useEffect(() => {
    initAllData();
  }, []);

  const initAllData = () => {
    const recipientSelectionEntityList = getRecipientsSelectionEntities({currentScopeUsers, currentGmtUsers, selectedScopeUserTypes, selectedSites, roles});

    // on edit mode, finds the saved associated usersIds of the mailing list
    // and filters as selectionEntities
    let foundedCurrentMailingListSelections = [];
    if (props?.isEditMode) {
      foundedCurrentMailingListSelections = recipientSelectionEntityList?.filter(selection => props?.mailingListToUsers?.some(mlto => mlto.userId === selection?.identifierId));
      
      props.handleChange({[INPUTS_PROPS.MAILING_LIST_PARKERS]: foundedCurrentMailingListSelections });
      setFoundedSelectionEntities(foundedCurrentMailingListSelections);
    }

    setRecipientsSelectionEntities(recipientSelectionEntityList);
  };

  if (props.currentStep !== ADD_MAILING_LIST_FORM_STEPS.MAILING_LIST_DETAILS) {
    return null;
  }
  
  return (
    <div className={classes.stepContainer}>
      <div className={classes.fileds}>
        <TextInput
          label={`${Strings.INPUT_LABELS.MAILING_LIST_NAME}*`}
          id={INPUTS_PROPS.MAILING_LIST_NAME}
          value={props.mailingListName}
          defaultValue={props.mailingListName}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleInputInfo={handleInputInfo}
          isRequired={true}
          hasError={!isRequired(props.mailingListName).isValid || !isLengthCharValid(props.mailingListName, LENGTHS.MAX_INPUT_LENGTH).isValid}
          errorMessage={getErrorMessage(isRequired(props.mailingListName)) ? getErrorMessage(isRequired(props.mailingListName)) : 
                        getErrorMessage(isLengthCharValid(props.mailingListName, LENGTHS.MAX_INPUT_LENGTH)) && 
                        getErrorMessage(isLengthCharValid(props.mailingListName, LENGTHS.MAX_INPUT_LENGTH))}
        />

        <div className={classes.mailingListTitlesContainer}>
            <div className={classes.stepTitle}>
                {Strings.STEPS_TITLES.MAILING_LIST_DETAILS_TITLE}
            </div>
            <span className={classes.stepSubTitle}>
                {Strings.STEPS_TITLES.MAILING_LIST_DETAILS_SUB_TITLE}
            </span>
        </div>
        
        <div className={classes.mailingListFieldsContainer}>
            <MultiSelectBoxInput 
              id={INPUTS_PROPS.MAILING_LIST_PARKERS}
              label={`${Strings.INPUT_LABELS.MAILING_LIST_PARKERS}*`}
              items={recipientsSelectionEntities}
              foundedItems={foundedSelectionEntities}
              showTotal={true}
              // startAdornment={<img src={Icons.SEARCH} />}
              //placeholder={'Users'}
              onItemClicked={(items) => {
                props.handleChange({[INPUTS_PROPS.MAILING_LIST_PARKERS]: items });
              }}
              isRequired={true}
              handleInputInfo={handleInputInfo}
              hasError={!arrayNotEmpty(props.mailingListParkers).isValid}
              errorMessage={getErrorMessage(arrayNotEmpty(props.mailingListParkers))}            
              isStepSubmitted={props.isStepSubmitted}
            />
        </div>       
      </div>
    </div>
  );
};

export default MailingListDetailsStep;
